export default "__VITE_ASSET__a191b06d__"